import React, { FC } from 'react';
import { Box, Card, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useGlobalClient } from 'hooks';
import { useHistory } from 'react-router-dom';
import * as paths from 'paths';
import { useLocation } from 'react-router';

const useStyles = makeStyles(theme => ({
  loginToShare: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  loginButton: {
    borderRadius: 16,
    width: 200,
  },
}));

const LoginPublic: FC = () => {
  const client = useGlobalClient();
  const classes = useStyles();
  const history = useHistory();

  const { t } = useTranslation();
  const { pathname } = useLocation();
  const encodedPath = encodeURIComponent(pathname);
  const landing_path = `${paths.login}?landing_path=${encodedPath}`;

  if (!client.public_post_force_login) {
    return null;
  }

  return (
    <Card className={classes.loginToShare}>
      <Typography gutterBottom variant="subtitle2" align="center">
        {t('auth:memberOf', { client: client.title })}
      </Typography>
      <Typography variant="subtitle2" align="center">
        {t('auth:loginToShare')}
      </Typography>
      <Box textAlign="center" marginTop={2}>
        <Button
          variant="contained"
          color="primary"
          className={classes.loginButton}
          onClick={() => history.push(landing_path)}
        >
          {t('auth:loginOrSignup')}
        </Button>
      </Box>
    </Card>
  );
};

export default LoginPublic;
